const textToolNode = (data) => {
  return {
    type: 'text',
    id: 'text-node',
    content: data.toolData,
  };
};

export { textToolNode };
